module.exports = __webpack_public_path__ + "static/media/logo512.d834be1d.png";